import { defineComponent as d, openBlock as H, createElementBlock as a, mergeProps as p, unref as V, renderSlot as i, createElementVNode as o, createCommentVNode as m } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, h = { key: 2 }, M = { key: 3 }, f = { key: 4 }, k = { key: 5 }, y = {
  name: "ScalarIconCopy"
}, _ = /* @__PURE__ */ d({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const l = n, { bind: r, weight: e } = u(l);
    return (s, t) => (H(), a("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, V(r)), [
      i(s.$slots, "default"),
      V(e) === "bold" ? (H(), a("g", Z, t[0] || (t[0] = [
        o("path", { d: "M216,28H88A12,12,0,0,0,76,40V76H40A12,12,0,0,0,28,88V216a12,12,0,0,0,12,12H168a12,12,0,0,0,12-12V180h36a12,12,0,0,0,12-12V40A12,12,0,0,0,216,28ZM156,204H52V100H156Zm48-48H180V88a12,12,0,0,0-12-12H100V52H204Z" }, null, -1)
      ]))) : V(e) === "duotone" ? (H(), a("g", g, t[1] || (t[1] = [
        o("path", {
          d: "M216,40V168H168V88H88V40Z",
          opacity: "0.2"
        }, null, -1),
        o("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" }, null, -1)
      ]))) : V(e) === "fill" ? (H(), a("g", h, t[2] || (t[2] = [
        o("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Zm-8,128H176V88a8,8,0,0,0-8-8H96V48H208Z" }, null, -1)
      ]))) : V(e) === "light" ? (H(), a("g", M, t[3] || (t[3] = [
        o("path", { d: "M216,34H88a6,6,0,0,0-6,6V82H40a6,6,0,0,0-6,6V216a6,6,0,0,0,6,6H168a6,6,0,0,0,6-6V174h42a6,6,0,0,0,6-6V40A6,6,0,0,0,216,34ZM162,210H46V94H162Zm48-48H174V88a6,6,0,0,0-6-6H94V46H210Z" }, null, -1)
      ]))) : V(e) === "regular" ? (H(), a("g", f, t[4] || (t[4] = [
        o("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" }, null, -1)
      ]))) : V(e) === "thin" ? (H(), a("g", k, t[5] || (t[5] = [
        o("path", { d: "M216,36H88a4,4,0,0,0-4,4V84H40a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H168a4,4,0,0,0,4-4V172h44a4,4,0,0,0,4-4V40A4,4,0,0,0,216,36ZM164,212H44V92H164Zm48-48H172V88a4,4,0,0,0-4-4H92V44H212Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  _ as default
};
